function findSelectedLabel(data, selectedValue) {
    return data.find(item => item.value === selectedValue)?.label || ""
}

export { findSelectedLabel }